import React, { useContext, useEffect } from 'react';
import styled from 'styled-components';
import { rgba } from 'polished';
import { ShadowOrBorderBox } from './mainCategory/StyledComponents';
import { Context } from './MunicipalNoticeBoard';
import { useHistory } from 'react-router-dom';

const ModalBackdrop = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: ${(props) => rgba(props.theme.backgroundColor || '#ffffff', 0.5)};
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Modal = styled(ShadowOrBorderBox)`
    font-family: 'Nunito', serif;
    border-radius: 1rem;
    padding: 2rem 3rem;
    background-color: ${(props) => rgba(props.theme.secondColor, 1)};
    color: ${(props) => props.theme.mainColor};

    > h2 {
        font-size: 2.5rem;
    }
`;

const Button = styled.div`
    font-size: 1.5rem;
    background-color: ${(props) => props.theme.mainColor};
    color: ${(props) => props.theme.secondColor};
    padding: 1rem 2rem;
    display: inline-block;
    border-radius: 0.6rem;
`;

export const IdleModal: React.FC<{ showIdleModal: boolean; resetSession: (reset: boolean) => void }> = ({
    showIdleModal,
    resetSession,
}) => {
    const { idleTimeoutSec = 10 } = useContext(Context);

    useEffect(() => {
        if (idleTimeoutSec) {
            //   idleTimer.start();
        } else {
            //  idleTimer.pause();
        }
    }, [idleTimeoutSec]);

    useEffect(() => {
        let timeout: NodeJS.Timeout;
        if (showIdleModal) {
            timeout = setTimeout(() => {
                console.log('check check');
                resetSession(true);
                //  const countDown = idleTimer.getRemainingTime();
                // console.log(countDown);
                //  setCountdown(Math.round(countDown / 1000));
            }, 10000);
        }
        return () => {
            timeout && clearInterval(timeout);
        };
    }, [showIdleModal]);

    if (showIdleModal) {
        return (
            <>
                <ModalBackdrop>
                    <Modal>
                        <h2>Inaktivität erkannt</h2>
                        <Button style={{ marginRight: '1em' }} onClick={() => resetSession(false)}>
                            Fortsetzen
                        </Button>
                        <Button onClick={() => resetSession(true)}>Session neu starten</Button>
                    </Modal>
                </ModalBackdrop>
            </>
        );
    }

    return <></>;
};
